import {MyDeviceRequestContainerModel} from './my-device-request-container.model';
import {MyContainerSharedMetadataModel} from './my-container-shared-metadata.model';
import {ProductModel} from './product.model';
import {RequestedNotDeviceItemModel} from './requested-not-device-item.model';
import {MyProductAmountModel} from './my-product-amount.model';
import {MyContainerDeviceDedicatedSupplyMetadata} from './my-container-device-dedicated-supply-metadata.model';

/*
* container for warranties, supplies and accessories
 */
export class MyNotDeviceRequestContainerModel {

    id: string;
    itemToOrder: ProductModel;
    isDevice: boolean;


    waAcLsAmount: MyProductAmountModel;  // used for warranties and accessories amount only

    parentDeviceDedicatedGeneralSupplyMetadata: MyContainerDeviceDedicatedSupplyMetadata;
    noParentGeneralSupplyAmount: MyProductAmountModel;

    parentPrintSmartDedicatedSupplyAmount: MyProductAmountModel;


    containerSharedMetadata: MyContainerSharedMetadataModel;
    notDeviceRequest: RequestedNotDeviceItemModel;
    parent: MyDeviceRequestContainerModel;


    // resets all amount values except parentPrintSmartDedicatedSupplyAmount, because it doenst come form user input
    public static resetUserInputAmounts(container: MyNotDeviceRequestContainerModel ) {
        container.waAcLsAmount = null;
        container.parentDeviceDedicatedGeneralSupplyMetadata = null;
        container.noParentGeneralSupplyAmount = null;
        // container.parentPrintSmartDedicatedSupplyAmount = null;
    }
}


